'use client';

import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { TradeDownIcon, TradeUpIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import Link from 'next/link';
import { FaLock } from 'react-icons/fa';
import { FaChevronRight } from 'react-icons/fa6';
import Preloader from '../preloader/components/Preloader';
import NextImage from '../Image';

const MyRewards = () => {
  const { data, isLoading } = useFetcherCSR(`/api/v2/user-memberships`);

  const { balance } = data || {};
  // const balance = 10;
  const next_memberships = data?.next_memberships || {};
  const memberships = data?.memberships || [];

  const maxMinRewardPoint = Math.max(
    ...memberships?.map((m: any) => m.min_reward_point)
  );

  const progressPercent = (balance / maxMinRewardPoint) * 100;

  return (
    <div className="dashboard__content">
      <div className="dashboard__content-header">
        <h5>My Rewards</h5>
      </div>

      <div className="dashboard__content-info">
        <div className="my-rewards ">
          <div className="my-rewards__card">
            <div className="row justify-content-between align-items-center mb-3">
              <div className="col-auto mb-4">
                <div className="my-rewards__membership">
                  <div className="my-rewards__membership-title">
                    <h4>
                      {' '}
                      <Link href="#">Membership</Link>{' '}
                    </h4>
                  </div>
                  <div className="my-rewards__membership-levels">
                    {memberships.map((membership: any) => (
                      <span key={membership.id} className="">
                        {membership.is_unlocked ? (
                          <NextImage
                            width={20}
                            height={20}
                            src={membership.icon}
                            alt={membership?.title}
                          />
                        ) : (
                          <FaLock />
                        )}
                        {membership?.title}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="my-rewards__progress">
                  <div className="d-flex justify-content-between my-rewards__scale position-relative">
                    {memberships.map((membership: any) => (
                      <span
                        className="position-absolute border rounded-2 py-1 px-2 reward-point-level"
                        key={membership?.id}
                        style={{
                          top: '-36px',
                          left: `${(membership?.min_reward_point / 300) * 100}%`,
                          transform: 'translateX(-50%)',
                        }}
                      >
                        {membership?.min_reward_point}
                      </span>
                    ))}
                  </div>

                  <div className="progress my-rewards__progress-bar">
                    <div
                      className="progress-bar my-rewards__progress-fill"
                      role="progressbar"
                      style={{ width: `${progressPercent}%` }}
                    ></div>
                  </div>

                  <p className="my-rewards__text mt-2 mb-0">
                    <strong>Get {next_memberships?.need_point}</strong> more
                    points to become a {next_memberships?.title} member within{' '}
                    {next_memberships?.last_date}
                  </p>
                </div>
              </div>
            </div>

            <div className="d-flex flex-wrap justify-content-between align-items-center my-rewards__balance">
              <div>
                <p className="my-rewards__balance-label">Balance</p>
                <h4 className="my-rewards__balance-points">{balance} Points</h4>
              </div>
              <Link
                href={'/reward/history'}
                className="trk-btn trk-btn--primary mt-3 mt-md-0"
              >
                Points History
              </Link>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-6">
              <div className="my-rewards__info-box my-rewards__info-box--earn">
                <div className="my-rewards__info-icon">
                  <HugeiconsIcon icon={TradeUpIcon} size={32} />
                </div>
                <div className="my-rewards__info-content">
                  <h6 className="mb-3">How To Earn Points</h6>
                  <ul className="mb-3">
                    <li className="mb-2">
                      For every 100 BDT spent on product purchases, you'll
                      continue to earn even more points!
                    </li>
                    <li className="mb-2">
                      Product Reviews: Earn 5 points per review.
                    </li>
                    <li className="mb-2">
                      Community Posts: Earn 3 points per post.
                    </li>
                  </ul>
                  <Link href="/reward/details">
                    Earn Points <FaChevronRight />
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-md-6 mt-3 mt-md-0">
              <div className="my-rewards__info-box my-rewards__info-box--redeem">
                <div className="my-rewards__info-icon">
                  <HugeiconsIcon icon={TradeDownIcon} size={32} />
                </div>
                <div className="my-rewards__info-content">
                  <h6 className="mb-3">How To Redeem Points</h6>
                  <ul className="mb-3">
                    <li className="mb-2">
                      Customers need to have a minimum 100 points to redeem
                    </li>
                    <li className="mb-2">
                      After 100 points, it can be redeemed in the multiple of 50
                    </li>
                  </ul>
                  <Link href="/reward/details">
                    Redeem Points <FaChevronRight />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyRewards;
